import { jwtDecode } from 'jwt-decode';

const TOKEN_KEY = 'agendario_jwt_token';
const LOGIN_URL = import.meta.env.VITE_LOGIN_URL || 'http://localhost:5000';

export const authService = {
  /**
   * Salva o token JWT no localStorage
   */
  setToken(token) {
    localStorage.setItem(TOKEN_KEY, token);
  },

  /**
   * Obtém o token JWT do localStorage
   */
  getToken() {
    const token = localStorage.getItem(TOKEN_KEY);
    console.log('[authService.getToken] Buscando token em localStorage[' + TOKEN_KEY + ']:', token ? 'ENCONTRADO' : 'NÃO ENCONTRADO');
    return token;
  },

  /**
   * Remove o token JWT do localStorage
   */
  removeToken() {
    localStorage.removeItem(TOKEN_KEY);
  },

  /**
   * Verifica se o token é válido (não expirado)
   */
  isTokenValid() {
    const token = this.getToken();
    if (!token) return false;

    try {
      const decoded = jwtDecode(token);
      const currentTime = Date.now() / 1000;
      
      // Token expira em menos de 5 minutos? Consideramos inválido
      if (decoded.exp < currentTime + 300) {
        return false;
      }

      return decoded.exp > currentTime;
    } catch (error) {
      console.error('Erro ao decodificar token:', error);
      return false;
    }
  },

  /**
   * Obtém informações do usuário decodificando o token
   */
  getUserInfo() {
    const token = this.getToken();
    if (!token) return null;

    try {
      const decoded = jwtDecode(token);
      return {
        userId: decoded.userId || decoded.sub,
        email: decoded.email,
        name: decoded.name,
        theme: decoded.theme ? parseInt(decoded.theme) : null,
        isNewUser: decoded.isNewUser === 'true' || decoded.isNewUser === true,
        exp: decoded.exp
      };
    } catch (error) {
      console.error('Erro ao decodificar token:', error);
      return null;
    }
  },

  /**
   * Obtém o tema do usuário do JWT
   * @returns {number|null} Valor do enum ThemeType ou null se não definido
   */
  getThemeFromToken() {
    const userInfo = this.getUserInfo();
    return userInfo?.theme || null;
  },

  /**
   * Verifica se é um novo usuário
   * @returns {boolean}
   */
  isNewUser() {
    const userInfo = this.getUserInfo();
    return userInfo?.isNewUser === true;
  },

  /**
   * Redireciona para a página de login
   */
  redirectToLogin() {
    this.removeToken();
    // Usar a origem atual (localhost ou domínio hospedado)
    const currentUrl = window.location.origin;
    const loginUrlWithReturn = `${LOGIN_URL}?returnUrl=${encodeURIComponent(currentUrl)}`;
    console.log('[authService.redirectToLogin] Redirecionando para:', loginUrlWithReturn);
    window.location.href = loginUrlWithReturn;
  },

  /**
   * Processa token recebido via query string após login
   */
  processLoginCallback() {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    
    console.log('[authService] processLoginCallback - token na URL?', token ? 'SIM' : 'NÃO');
    
    if (token) {
      console.log('[authService] Salvando token no localStorage...');
      this.setToken(token);
      console.log('[authService] Token salvo. Verificando...');
      const saved = this.getToken();
      console.log('[authService] Token recuperado do localStorage?', saved ? 'SIM' : 'NÃO');
      // Remove token da URL
      window.history.replaceState({}, document.title, window.location.pathname);
      return true;
    }
    
    console.log('[authService] Nenhum token na URL');
    return false;
  },

  /**
   * Verifica autenticação e redireciona se necessário
   */
  checkAuth() {
    console.log('[authService.checkAuth] Iniciando verificação de autenticação...');
    // Primeiro verifica se há token no query string
    const hasNewToken = this.processLoginCallback();
    console.log('[authService.checkAuth] Resultado de processLoginCallback:', hasNewToken);
    
    if (hasNewToken) {
      console.log('[authService.checkAuth] Token novo processado, autenticado!');
      return true;
    }

    // Verifica se o token atual é válido
    if (!this.isTokenValid()) {
      console.log('[authService.checkAuth] Token não válido, redirecionando para login');
      this.redirectToLogin();
      return false;
    }

    console.log('[authService.checkAuth] Token válido');
    return true;
  }
};
